module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAXCAYAAAA7kX6CAAAAxUlEQVQ4jZXUTUoDMRQA4K9lzuHOXelhii4U3JR6JylFQUQXo3ijFt0IPUMpbhoIYSZ5EwghIR8vPy+Z/S2WgqXDK77RdxPQO24v1XwiSv1VK2KHD9xkY594qEUcQ3c4jcEqYniPTTQEQ6iEYZTDSSjBySjBtwL94r6GEvwqJl3hCbMW7C8R9tn4GrsaTofT4xovUZxfxxkbPEdwmQBnPEbwUMqF8FiSN3HtPSacUN5uWg95DB8jX0e57B9so59VwkdscfgHSKtA52Qp3ukAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/main-menu/icon-mobile_arrow-back.png
// module id = 819
// module chunks = 0